import { routes } from '../../../routes';
import React from 'react';
import { Route } from '../../../../../utils/router';
import PageHeaderNav from '../../../components/PageHeaderNav';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';

type TabItem = {
  label: string;
  route: Route<string[]>;
};

const i18Path = 'shifts.subMenuItems';

const SchedulerShiftsNav: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);

  const tabItems: TabItem[] = [
    {
      label: t('schedulerShifts.title'),
      route: routes.schedulerShifts.route,
    },
  ];

  // Only show the tabs nav if there are multiple tabs (we will add more tabs in the future)
  if (tabItems.length === 1) {
    return null;
  }

  return <PageHeaderNav tabItems={tabItems} />;
};

export default SchedulerShiftsNav;
